import { useEffect, useState } from 'react';

const API = `${window.location.protocol}//${window.location.hostname}/api`;
function api(path) {
  const token = localStorage.getItem('token');
  return fetch(`${API}${path}`, { headers: { Authorization: `Bearer ${token}` } }).then(async r => {
    const d = await r.json().catch(() => ([]));
    if (!r.ok) throw new Error(d.message || d.error || `HTTP ${r.status}`);
    return d;
  });
}

const card = { backgroundColor: '#1e293b', border: '1px solid #334155', borderRadius: 8, padding: 14, marginBottom: 10 };
const th = { textAlign: 'left', color: '#64748b', fontSize: 11, fontWeight: 700, textTransform: 'uppercase', padding: '8px 10px', borderBottom: '1px solid #334155' };
const td = { color: '#e2e8f0', fontSize: 13, padding: '8px 10px', borderBottom: '1px solid #0f172a' };

export default function MaterialsView() {
  const [tab, setTab] = useState('stock');
  const [stock, setStock] = useState([]);
  const [received, setReceived] = useState([]);
  const [stockLocs, setStockLocs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState('');

  useEffect(() => {
    Promise.all([api('/materials/stock'), api('/materials/received'), api('/materials/stock-locations')])
      .then(([s, r, sl]) => { setStock(Array.isArray(s) ? s : []); setReceived(Array.isArray(r) ? r : []); setStockLocs(Array.isArray(sl) ? sl : []); })
      .catch(e => setErr(e.message))
      .finally(() => setLoading(false));
  }, []);

  const TabBtn = ({ id, label, count }) => (
    <button onClick={() => setTab(id)} style={{
      padding: '8px 16px', borderRadius: 7, border: 'none', cursor: 'pointer', fontSize: 14, fontWeight: 700,
      backgroundColor: tab === id ? '#1e3a5f' : 'transparent', color: tab === id ? '#93c5fd' : '#94a3b8',
    }}>{label}{count != null ? ` (${count})` : ''}</button>
  );

  return (
    <div style={{ flex: 1, overflowY: 'auto', backgroundColor: '#0f172a', color: '#e2e8f0', fontFamily: 'sans-serif', padding: 24 }}>
      <div style={{ maxWidth: 1000, margin: '0 auto' }}>
        <div style={{ fontSize: 22, fontWeight: 800, marginBottom: 4 }}>Materials</div>
        <div style={{ color: '#64748b', fontSize: 13, marginBottom: 18 }}>Shared stock pool and all received material across jobs.</div>

        <div style={{ display: 'flex', gap: 6, marginBottom: 18 }}>
          <TabBtn id="stock" label="In Stock" count={stock.length} />
          <TabBtn id="received" label="Received" count={received.length} />
          <TabBtn id="locations" label="Drop-off QRs" count={stockLocs.length} />
        </div>

        {err && <div style={{ color: '#f87171', fontSize: 13, marginBottom: 12, fontWeight: 700 }}>{err}</div>}
        {loading && <div style={{ color: '#64748b', fontSize: 13 }}>Loading…</div>}

        {/* ── In Stock ────────────────────────────── */}
        {!loading && tab === 'stock' && (
          stock.length === 0 ? (
            <div style={{ textAlign: 'center', padding: 40, color: '#475569' }}>
              <div style={{ fontSize: 28, marginBottom: 8 }}>📦</div>
              <div style={{ fontSize: 14 }}>Nothing in stock yet.</div>
              <div style={{ fontSize: 12, marginTop: 4 }}>Material returned from jobs will show up here.</div>
            </div>
          ) : (
            <table style={{ width: '100%', borderCollapse: 'collapse', ...card, padding: 0, overflow: 'hidden' }}>
              <thead><tr>
                <th style={th}>Item</th><th style={th}>Part #</th><th style={th}>Qty</th>
                <th style={th}>Stock Location</th><th style={th}>Team</th><th style={th}>From Job</th>
              </tr></thead>
              <tbody>
                {stock.map(s => (
                  <tr key={s.id}>
                    <td style={td}>{s.description}</td>
                    <td style={td}>{s.part_number || '—'}</td>
                    <td style={td}>{s.qty} {s.unit || ''}</td>
                    <td style={td}>{s.location_name || '—'}</td>
                    <td style={td}>{s.team_name || '—'}</td>
                    <td style={td}>{s.source_work_item_title || '—'}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )
        )}

        {/* ── Received ────────────────────────────── */}
        {!loading && tab === 'received' && (
          received.length === 0 ? (
            <div style={{ textAlign: 'center', padding: 40, color: '#475569' }}>
              <div style={{ fontSize: 28, marginBottom: 8 }}>📥</div>
              <div style={{ fontSize: 14 }}>No received material yet.</div>
            </div>
          ) : received.map(r => (
            <div key={r.shipment_id} style={card}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', marginBottom: 8 }}>
                <div style={{ fontWeight: 700, fontSize: 14 }}>{r.work_item_title}
                  {r.wo_number && <span style={{ color: '#64748b', fontWeight: 400, marginLeft: 8 }}>WO {r.wo_number}</span>}
                </div>
                <div style={{ fontSize: 11, color: '#64748b' }}>
                  {r.po_number ? `PO ${r.po_number} · ` : ''}{r.received_at ? new Date(r.received_at).toLocaleDateString() : ''}
                </div>
              </div>
              {(r.items || []).map((i, idx) => (
                <div key={idx} style={{ display: 'flex', justifyContent: 'space-between', fontSize: 13, color: '#94a3b8', padding: '3px 0', borderBottom: '1px solid #0f172a' }}>
                  <span>{i.description}{i.part_number ? ` · ${i.part_number}` : ''}</span>
                  <span>{i.received_qty} {i.unit || ''}</span>
                </div>
              ))}
            </div>
          ))
        )}

        {/* ── Drop-off QRs (stock locations) ──────── */}
        {!loading && tab === 'locations' && (
          stockLocs.length === 0 ? (
            <div style={{ textAlign: 'center', padding: 40, color: '#475569' }}>
              <div style={{ fontSize: 28, marginBottom: 8 }}>🏷️</div>
              <div style={{ fontSize: 14 }}>No stock locations yet.</div>
              <div style={{ fontSize: 12, marginTop: 4 }}>Mark a site as a stock location to get a drop-off QR.</div>
            </div>
          ) : (
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 16 }}>
              {stockLocs.map(sl => (
                <div key={sl.id} style={{ ...card, width: 240, textAlign: 'center' }}>
                  <div style={{ fontWeight: 700, marginBottom: 8 }}>{sl.name}</div>
                  <img src={`${API}/material-stock-image/${sl.id}`} alt="Drop-off QR" style={{ width: 180, height: 180, backgroundColor: 'white', borderRadius: 6 }} onError={e => { e.target.style.display = 'none'; }} />
                  <div style={{ fontSize: 11, color: '#64748b', marginTop: 6 }}>Scan to drop off / return material</div>
                </div>
              ))}
            </div>
          )
        )}
      </div>
    </div>
  );
}
